export { Pill, type PillProps } from "./Pill";
